export default {
  profile() {
    const tag = document.querySelector("#threatmetrix-script");
    if (tag) tag.parentNode.removeChild(tag);

    const s = document.createElement("script");
    s.id = "threatmetrix-script";
    s.src = "https://s.latamstatic.com/files/pdffp/pdffp-p.js";
    document.body.appendChild(s);
  }
};
